import PrintConsultantNotes from "components/FollowUpVisit/PrintConsultantNotes"
import { getAllConsultantReferralDetails, getManageStaffDetailsById } from "core/services/api"
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template"
import defaultSurveyConfig from "pages/RMO/components/cancerTemplateForm/template"
import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router"
import Select from "react-select"
import Toast from "../../components/Toast"
import {
  checkIcdDrugInteraction,
  getGeneticCounsellorDetails,
  getPhysiotherapistDetails,
  getPsychologistDetails,
  saveGeneticProgressNotes,
  savePhysiotherapyProgressNotes,
  savePsychologyProgressNotes,
} from "../../core/services/api/patientClinicalService"
import {
  addConsultantNotes,
  getConsultantNotesData
} from "../../core/services/api/patientDiagnosisService"
import { MocUserRole } from "../../core/services/models/Enums"
import Button from "../Button"
import InputField from "../InputField"
import TreatmentPlan from "../TreatmentPlan"
import "./ConsultantNotesView.scss"
import Print from "components/Print/Print"

export default function ConsultantNotesView({
  setResFollowUpData,
  setResConsultantNoteData,
  setIsConsultantNoteData,
  setIsFollowUpData,
  recordDetails,
  appointmentDetails,
  patientDetail,
  isReadOnly,
  selectedIpdTab,
  staffType,
  smartSummaryData
}: any) {
  // add treatment plan
  const treatmentPlan = {
    type: "",
    medicine: "",
    standardDose: "",
    dose: "",
    doseModification: "",
    notes: "",
    duration: "",
  }
  let [treatmentPlans, setTreatmentPlans] = useState([treatmentPlan])
  // add prescription plan
  const prescriptionPlan = {
    type: "",
    medicineName: "",
    dose: "",
    when: "",
    frequency: "",
    duration: "",
    instructions: "",
  }
  let [prescriptionPlans, setPrescriptionPlans] = useState([prescriptionPlan])
  const location = useLocation()
  const followUpPrintRef = useRef(null)
  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const appointmentType = appointmentDetails?.appointmentType
  const recordId = recordDetails?.id
  const patientId = appointmentDetails?.patientId

  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const componentRef = useRef(null)

  const referredTo = {
    doctorName: "",
    speciality: "",
    phoneNo: "",
    emailId: "",
  }

  const followUpOptions = {
    speciality: [
      "Medical Oncologist",
      "Radiation oncologist",
      "Onco-surgeon",
      "Onco-pathologist",
      "Cardiologist",
      "Dentist",
      "Dermatologist",
      "Endocrinologist",
      "Gastroenterologist",
      "Gynecologist",
      "Hematologist",
      "Hepatologist",
      "Immunologist",
      "Nephrologist",
      "Neurologist",
      "Pulmonologist",
      "Ophthalmologist",
      "Orthopedics",
      "Pediatrician",
      "Podiatrist",
      "Urologist",
      "ENT",
      "Rheumatologist",
      "Surgical gastroenterologist",
      "Diabetologist",
      "Physician",
      "Neuro physician",
      "Radiologist",
      "Pathologist",
      "Surgeon",
      "General surgeon",
      "Plastic surgeon",
      "Neurosurgeon",
      "CVT surgeon",
      "Vascular surgeon",
      "Dental surgeon",
      "Retina surgeon",
      "Foot surgeon",
      "Nuclear medicine",
      "Physiotherapist",
      "Psychologist",
      "Psychiatrist",
      "Counselor",
      "Nutritionist",
      "Dietician",
      "Genetic counselor",
      "Geriatric physician",
    ],
  }
  const daysofYear = {
    daysofweek: [
      "Days",
      "Months",
      "Year",
      "Week"
    ]
  }
  let [referredTos, setReferredTos] = useState([referredTo])

  const testRequest = { testName: "", duration: "", when: "" }
  const [testsRequested, setTestsRequested] = useState([testRequest])
  const [notes, setNotes] = useState<any>("")
  const [physioAdditionalNotes, setPhysioAdditionalNotes] = useState<any>("")
  const [psychologyAdditionalNotes, setPsychologyAdditionalNotes] = useState<any>("")
  const [consultantNotesData, setConsultantNotesData] = useState<any>(
    // {
    // advice: "",
    // nextVisit: "",
    // nextVisit1: "",
    // nextVisit2: "",
    // }
  )
  // add medicine Details
  const medicineDetail = {
    type: "",
    medicineName: "",
    dose: "",
    when: "",
    frequency: "",
    duration: "",
    instructions: "",
  }
  let [medicineDetails, setMedicineDetails] = useState([medicineDetail])
  const [isConsultantNoteSubmit, setIsConsultantNoteSubmit] = useState(false)
  const [formConsultantNoteErrors, setFormConsultantNoteErrors] = useState({})
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState("")
  const [specalityValue, setSpecalityValue] = useState('')
  const signaturePanelJSONGC = {
    "logoPosition": "right",
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "expression",
            "name": "geneticCounsellorHeading",
            "title": "Genetic Counsellor",
            "hideNumber": true
          },
          {
            "type": "text",
            "name": "geneticCounsellorName",
            "title": "Name: ",
            "hideNumber": true,
            "isRequired": true
          },
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "geneticCounsellorSignature",
            "startWithNewLine": false,
            "title": "Signature:",
            "hideNumber": true,
            "isRequired": true
          }
        ]
      }
    ],
    "showCompletedPage": false,
    "completeText": "Save"
  }
  const signaturePanelJSON = {
    "logoPosition": "right",
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "text",
            "name": "subConsultantName",
            "title": "Name: ",
            "hideNumber": true,
            "isRequired": true
          },
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "subConsultantSignature",
            "startWithNewLine": false,
            "title": "Signature:",
            "hideNumber": true,
            "isRequired": true
          }
        ]
      }
    ],
    "showCompletedPage": false,
    "completeText": "Save"
  }
  const [templateJSON, setTemplateJSON] = useState<any>(
    userRole === (userRole === MocUserRole.GENETIC_COUNSELLOR && staffType?.toLowerCase() === "genetic_counsellor") || selectedIpdTab === "Genetic Counsellor" ? signaturePanelJSONGC : signaturePanelJSON)
  const [savedTemplate, setSavedTemplate] = useState<any>()
  const [signatureData, setSignatureData] = useState<any>({})
  const [staffDetails, setStaffDetails] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  //Referal Doctors
  const [referalConsultants, setReferalConsultants] = useState<any>([])
  const [referalConsultantsOptions, setReferalConsultantsOptions] = useState<any>([])

  useEffect(() => {
    // setIsLoading(true)
    fetchFollowUpDetails()
  }, [])

  const fetchFollowUpDetails = async () => {
    // setIsLoading(true)
    let referalConsultantsData: any = []
    try {
      referalConsultantsData = await getAllConsultantReferralDetails(userDetail?.currentCenter?.centerId)
      const referalDoctorOptions = referalConsultantsData?.map((ele: any) => {
        return { label: ele?.consultantName, value: ele?.id }
      })
      referalDoctorOptions?.push({ label: "Others", value: "Others" })
      setReferalConsultants(referalConsultantsData)
      setReferalConsultantsOptions(referalDoctorOptions)
    }
    catch {
      console.log("Failed to fetch referral consultant details")
    }
    if ((userRole === MocUserRole.GENETIC_COUNSELLOR &&
      staffType?.toLowerCase() === "genetic_counsellor") ||
      selectedIpdTab === "Genetic Counsellor") {
      getGeneticCounsellorDetails(recordId)
        .then((data: any) => {
          const res = data?.progressNotes
          if (res) {
            setNotes(res?.notes)
            if (res?.referredTo) {
              const referredToFormatted: any = res?.referredTo?.map((each: any) => {
                if (each?.doctorName) {
                  const isConsulntantOthers = referalConsultantsData?.filter((con: any) => con?.consultantName === each["doctorName"])
                  if (isConsulntantOthers?.length <= 0) {
                    const temp: any = { ...each }
                    temp["doctorNameOthers"] = each?.doctorName
                    temp["doctorName"] = "Others"
                    return temp
                  } else {
                    return { ...each }
                  }
                } else {
                  return { ...each }
                }
              })
              setReferredTos(referredToFormatted)
            }
          }
          setTestsRequested(
            res?.testsRequired ? res?.testsRequired : [testRequest]
          )
          setPrescriptionPlans(
            res?.prescriptionPad ? res?.prescriptionPad : [prescriptionPlan]
          )
          setSignatureData(res?.signature)
          getDefaultSignatureData(res?.signature)
          if (res?.nextVisit?.split("$")?.length > 1) {
            let nexVisitTemp = res?.nextVisit?.split("$")
            setConsultantNotesData({
              advice: res?.advice,
              nextVisit: "",
              nextVisit1: nexVisitTemp[0],
              nextVisit2: nexVisitTemp[1],
            })
          } else {
            setConsultantNotesData({
              advice: res?.advice,
              nextVisit: res?.nextVisit,
              nextVisit1: "",
              nextVisit2: "",
            })
          }
          setIsLoading(false)
        })
        .catch((err: any) => {
          console.log(err)
          setIsLoading(false)
          getDefaultSignatureData({})
        })
    } else if ((userRole === MocUserRole.PHYSIOTHERAPIST &&
      staffType?.toLowerCase() === "physiotherapist") ||
      selectedIpdTab === "Physiotherapist") {
      getPhysiotherapistDetails(recordId)
        .then((data: any) => {
          const res = data?.progressNotes
          if (res) {
            setPhysioAdditionalNotes(res?.notes)
            if (res?.referredTo) {
              const referredToFormatted: any = res?.referredTo?.map((each: any) => {
                if (each?.doctorName) {
                  const isConsulntantOthers = referalConsultantsData?.filter((con: any) => con?.consultantName === each["doctorName"])
                  if (isConsulntantOthers?.length <= 0) {
                    const temp: any = { ...each }
                    temp["doctorNameOthers"] = each?.doctorName
                    temp["doctorName"] = "Others"
                    return temp
                  } else {
                    return { ...each }
                  }
                } else {
                  return { ...each }
                }
              })
              setReferredTos(referredToFormatted)
            }
          }
          setTestsRequested(
            res?.testsRequired ? res?.testsRequired : [testRequest]
          )
          setPrescriptionPlans(
            res?.prescriptionPad ? res?.prescriptionPad : [prescriptionPlan]
          )
          setSignatureData(res?.signature)
          getDefaultSignatureData(res?.signature)
          if (res?.nextVisit?.split("$")?.length > 1) {
            let nexVisitTemp = res?.nextVisit?.split("$")
            setConsultantNotesData({
              advice: res?.advice,
              nextVisit: "",
              nextVisit1: nexVisitTemp[0],
              nextVisit2: nexVisitTemp[1],
            })
          } else {
            setConsultantNotesData({
              advice: res?.advice,
              nextVisit: res?.nextVisit,
              nextVisit1: "",
              nextVisit2: "",
            })
          }
          setIsLoading(false)
        })
        .catch((err: any) => {
          console.log(err)
          setIsLoading(false)
          getDefaultSignatureData({})
        })
    } else if ((userRole === MocUserRole.PSYCHOLOGIST &&
      staffType?.toLowerCase() === "psychologist") ||
      selectedIpdTab === "Psychologist") {
      getPsychologistDetails(recordId)
        .then((data: any) => {
          const res = data?.progressNotes
          if (res) {
            setPsychologyAdditionalNotes(res?.notes)
            if (res?.referredTo) {
              const referredToFormatted: any = res?.referredTo?.map((each: any) => {
                if (each?.doctorName) {
                  const isConsulntantOthers = referalConsultantsData?.filter((con: any) => con?.consultantName === each["doctorName"])
                  if (isConsulntantOthers?.length <= 0) {
                    const temp: any = { ...each }
                    temp["doctorNameOthers"] = each?.doctorName
                    temp["doctorName"] = "Others"
                    return temp
                  } else {
                    return { ...each }
                  }
                } else {
                  return { ...each }
                }
              })
              setReferredTos(referredToFormatted)
            }
          }
          setTestsRequested(
            res?.testsRequired ? res?.testsRequired : [testRequest]
          )
          setPrescriptionPlans(
            res?.prescriptionPad ? res?.prescriptionPad : [prescriptionPlan]
          )
          setSignatureData(res?.signature)
          getDefaultSignatureData(res?.signature)
          if (res?.nextVisit?.split("$")?.length > 1) {
            let nexVisitTemp = res?.nextVisit?.split("$")
            setConsultantNotesData({
              advice: res?.advice,
              nextVisit: "",
              nextVisit1: nexVisitTemp[0],
              nextVisit2: nexVisitTemp[1],
            })
          } else {
            setConsultantNotesData({
              advice: res?.advice,
              nextVisit: res?.nextVisit,
              nextVisit1: "",
              nextVisit2: "",
            })
          }
          setIsLoading(false)
        })
        .catch((err: any) => {
          console.log(err)
          setIsLoading(false)
          getDefaultSignatureData({})
        })
    } else {
      getConsultantNotesData(patientId)
        .then((data: any) => {
          const res = data.data
          if (!res?.prescriptionPad) {
            setPrescriptionPlans([prescriptionPlan])
          }
          if (res?.referredTo) {
            const referredToFormatted: any = res?.referredTo?.map((each: any) => {
              if (each?.doctorName) {
                const isConsulntantOthers = referalConsultantsData?.filter((con: any) => con?.consultantName === each["doctorName"])
                if (isConsulntantOthers?.length <= 0) {
                  const temp: any = { ...each }
                  temp["doctorNameOthers"] = each?.doctorName
                  temp["doctorName"] = "Others"
                  return temp
                } else {
                  return { ...each }
                }
              } else {
                return { ...each }
              }
            })
            setReferredTos(referredToFormatted)
          }
          setTestsRequested(
            res?.testsRequired ? res?.testsRequired : [testRequest]
          )
          setPrescriptionPlans(res?.prescriptionPad)
          if (res?.nextVisit.split("$").length > 1) {
            let nexVisitTemp = res?.nextVisit.split("$")
            setConsultantNotesData({
              advice: res?.advice,
              nextVisit: "",
              nextVisit1: nexVisitTemp[0],
              nextVisit2: nexVisitTemp[1],
            })
          } else {
            setConsultantNotesData({
              advice: res?.advice,
              nextVisit: res?.nextVisit,
              nextVisit1: "",
              nextVisit2: "",
            })
          }
          setIsLoading(false)
        })
        .catch((err: any) => {
          console.log(err)
          setIsLoading(false)
        })
    }
  }

  const getDefaultSignatureData = (data: any) => {
    if (userDetail?.id) {
      getManageStaffDetailsById(userDetail?.id)
        .then((res: any) => {
          setStaffDetails(res)
          const temp = { ...data }
          if (userRole === MocUserRole?.GENETIC_COUNSELLOR) {
            if (!Object.keys(temp).includes("geneticCounsellorName")) {
              temp["geneticCounsellorName"] = res?.name
            }
            if (!Object.keys(temp).includes("geneticCounsellorSignature")) {
              temp["geneticCounsellorSignature"] = res?.signaturePicUrl
            }
          } else {
            if (!Object.keys(temp).includes("subConsultantName")) {
              temp["subConsultantName"] = res?.name
            }
            if (!Object.keys(temp).includes("subConsultantSignature")) {
              temp["subConsultantSignature"] = res?.signaturePicUrl
            }
          }
          setSignatureData({ ...temp })
        })
        .catch((err: any) => console.log(err?.message))
    }
  }

  useEffect(() => {
    if (isReadOnly) {
      const tempJson: any = { ...templateJSON }
      tempJson["pages"][0]["readOnly"] = true
      tempJson["showNavigationButtons"] = "none"
      setTemplateJSON(tempJson)
    }
  }, [isReadOnly])

  useEffect(() => {
    if (
      Object.keys(formConsultantNoteErrors).length === 0 &&
      isConsultantNoteSubmit
    ) {
      // setIsLoading(true)
      const referedTosCopy: any = referredTos?.map((each: any) => {
        const eachCopy = { ...each }
        if (Object.keys(eachCopy)?.includes("doctorNameOthers")) {
          if (eachCopy["doctorNameOthers"]) {
            eachCopy["doctorName"] = eachCopy["doctorNameOthers"]
            delete eachCopy["doctorNameOthers"]
          } else {
            delete eachCopy["doctorNameOthers"]
          }
        }
        const keys: any = Object.keys(eachCopy)
        if (keys?.length > 0) {
          keys?.forEach((eachKey: any) => {
            if (!eachCopy[eachKey]) {
              delete eachCopy[eachKey]
            }
          })
        }
        return eachCopy
      })
      const tempReferedTos: any = referedTosCopy?.filter((ele: any) => Object.keys(ele)?.length > 0)
      const updatedReferedTos: any = tempReferedTos?.length > 0 ? tempReferedTos : null
      const data = {
        ...consultantNotesData,
        prescriptionPlans,
        testsRequested,
        updatedReferedTos,
        notes,
        signatureData
      }
      const params = {
        centerId,
        consultantId,
        patientId,
        appointmentId,
        recordId,
      }

      if (userRole === MocUserRole.GENETIC_COUNSELLOR) {
        saveGeneticProgressNotes(data, params)
          .then((data) => {
            setResConsultantNoteData(data)
            setIsLoading(false)
            setIsConsultantNoteData(true)
            setTemplateJSON(savedTemplate)
          })
          .catch((err) => {
            console.log(err)
            setIsLoading(false)
          })
      } else if (userRole === MocUserRole.PHYSIOTHERAPIST) {
        data["notes"] = physioAdditionalNotes
        savePhysiotherapyProgressNotes(data, params)
          .then((data) => {
            setResConsultantNoteData(data)
            setIsLoading(false)
            setIsConsultantNoteData(true)
            setTemplateJSON(savedTemplate)
          })
          .catch((err) => {
            console.log(err)
            setIsLoading(false)
          })
      } else if (userRole === MocUserRole.PSYCHOLOGIST) {
        data["notes"] = psychologyAdditionalNotes
        savePsychologyProgressNotes(data, params)
          .then((data) => {
            setResConsultantNoteData(data)
            setIsLoading(false)
            setIsConsultantNoteData(true)
            setTemplateJSON(savedTemplate)
          })
          .catch((err) => {
            console.log(err)
            setIsLoading(false)
          })
      } else {
        addConsultantNotes(
          {
            ...consultantNotesData,

            // medicineDetails,

            prescriptionPlans,

            testsRequested,

            referredTos,
          },
          {
            centerId,
            consultantId,
            patientId,
            appointmentId,
            recordId,
          }
        )
          .then((data) => {
            setResConsultantNoteData(data)
            setIsLoading(false)
            setIsConsultantNoteData(true)
          })
          .catch((err) => {
            console.log(err)
            setIsLoading(false)
          })
      }
    }
  }, [formConsultantNoteErrors])

  const checkDrugInteraction = (values: any) => {
    checkIcdDrugInteraction(values)
      .then((res: any) => {
        let msg = ''
        if (res?.fullInteractionTypeGroup) {
          res?.fullInteractionTypeGroup[0]?.fullInteractionType.forEach((each: any) => msg += each?.comment)
          const temp = msg.split("asserted in DrugBank between")
          let displayText = ""
          for (let i = 1; i < temp.length; i += 2) {
            const parts = temp[i].split(".")
            displayText += `> Interaction found between${parts[0]}.\n`
          }
          if (displayText) {
            setMessage(displayText)
            setOpen(true)
          }
        }
      })
      .catch((err: any) => {
        console.log(err?.message)
      })
  }

  const specialityName: any = followUpOptions?.speciality.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const monthView: any = daysofYear?.daysofweek.map((ele: any) => {
    return { label: ele, value: ele }
  })

  function onValueChange(source: any, value: any) {
    const values: any = { ...referredTo }
    setReferredTos({ ...values, ...{ specalityValue: value } })
  }

  const validateConsultantNote = (values: any) => {
    const errors: any = {}
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
    return errors
  }

  const handleConsultantNoteSubmit = (e: any) => {
    if (e) {
      e.preventDefault()
    }
    setFormConsultantNoteErrors(validateConsultantNote(consultantNotesData))
    setIsConsultantNoteSubmit(true)
  }

  const handleSurveyCompletion = () => {
    setFormConsultantNoteErrors(validateConsultantNote(consultantNotesData))
    setSavedTemplate({ ...templateJSON })
    setTemplateJSON({})
    setIsConsultantNoteSubmit(true)
  }

  const getOriginOfPrint = () => {
    if ((userRole === MocUserRole.GENETIC_COUNSELLOR && staffType?.toLowerCase() === "genetic_counsellor") || selectedIpdTab === "Genetic Counsellor") {
      return "GENETIC_COUNSELLOR"
    } else if ((userRole === MocUserRole.PHYSIOTHERAPIST && staffType?.toLowerCase() === "physiotherapist") || selectedIpdTab === "Physiotherapist") {
      return "PHYSIOTHERAPIST"
    } else if ((userRole === MocUserRole.PSYCHOLOGIST && staffType?.toLowerCase() === "psychologist") || selectedIpdTab === "Psychologist") {
      return "PSYCHOLOGIST"
    }
  }

  return (
    <>
      {
        open && (
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => setOpen(false)}
          ></Toast>
        )
      }
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      <div className="print-btn" >
        <Print
          componentRef={followUpPrintRef}
        />
      </div>
      <form onSubmit={handleConsultantNoteSubmit}>
        <div className="consultant-notes-wrapper">
          {
            (
              (userRole !== MocUserRole.GENETIC_COUNSELLOR && staffType?.toLowerCase() !== "genetic_counsellor" && selectedIpdTab !== "Genetic Counsellor")
              &&
              (userRole !== MocUserRole.PHYSIOTHERAPIST && staffType?.toLowerCase() !== "physiotherapist" && selectedIpdTab !== "Physiotherapist")
              &&
              (userRole !== MocUserRole.PSYCHOLOGIST && staffType?.toLowerCase() !== "psychologist" && selectedIpdTab !== "Psychologist")
            ) && (
              <TreatmentPlan
                isEditable={true}
                prescriptionPlans={prescriptionPlans}
                setPrescriptionPlans={setPrescriptionPlans}
                checkDrugInteraction={checkDrugInteraction}
                isReadOnly={isReadOnly}
                patientId={patientId}
              />
            )
          }
          {
            ((userRole === MocUserRole.GENETIC_COUNSELLOR && staffType?.toLowerCase() === "genetic_counsellor") || selectedIpdTab === "Genetic Counsellor") && (
              <div className="advice mt-4">
                <div className="heading">Notes</div>
                <div className="textarea">
                  <textarea
                    cols={50}
                    rows={5}
                    value={notes}
                    onChange={(e) =>
                      setNotes(e.target.value)
                    }
                    disabled={isReadOnly}
                    className={isReadOnly ? "disabled" : ""}
                  />
                </div>

              </div>
            )
          }
          {
            (
              (userRole !== MocUserRole.PSYCHOLOGIST && staffType?.toLowerCase() !== "psychologist" && selectedIpdTab !== "Psychologist") &&
              (userRole !== MocUserRole.PHYSIOTHERAPIST && staffType?.toLowerCase() !== "physiotherapist" && selectedIpdTab !== "Physiotherapist")
            ) && (
              <div className="test-required mt-4">
                <div className="heading">Tests Required</div>
                <div className="custom-table">
                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Test Name</th>
                        <th>Instructions</th>
                        <th>Test(when)</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {testsRequested?.map((e, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              <InputField
                                handleChange={(e) => {
                                  const values = [...testsRequested]
                                  values[index].testName = e.target.value
                                  setTestsRequested([...values])
                                }}
                                value={testsRequested[index].testName}
                                readOnly={isReadOnly}
                              />
                            </td>
                            <td>
                              <InputField
                                handleChange={(e) => {
                                  const values = [...testsRequested]
                                  values[index].duration = e.target.value
                                  setTestsRequested([...values])
                                }}
                                value={testsRequested[index].duration}
                                readOnly={isReadOnly}
                              />
                            </td>
                            <td>
                              <InputField
                                calendar={true}
                                handleChange={(e) => {
                                  const values = [...testsRequested]
                                  values[index].when = e.target.value
                                  setTestsRequested([...values])
                                }}
                                value={testsRequested[index].when}
                                readOnly={isReadOnly}
                              />
                            </td>
                            <td>
                              {testsRequested.length > 1 ? (
                                !isReadOnly ?
                                  <div
                                    className="delete-icon"
                                    onClick={() => {
                                      if (testsRequested.length > 1) {
                                        const values = [...testsRequested]
                                        values.splice(index, 1)
                                        setTestsRequested(values)
                                      }
                                    }}
                                  >
                                    <img
                                      src="../../assets/images/delete-icon.svg"
                                      alt=""
                                    />
                                  </div> : "") : (
                                !isReadOnly ?
                                  <div
                                    className="delete-icon"
                                    style={{ cursor: "not-allowed" }}
                                  >
                                    <img
                                      src="../../assets/images/delete-icon.svg"
                                      alt=""
                                    />
                                  </div> : ""
                              )
                              }
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  {
                    !isReadOnly ?
                      <div className="comorbidities add-new mr-2">
                        <div
                          className="add-new-button"
                          onClick={() =>
                            setTestsRequested([...testsRequested, testRequest])
                          }
                        >
                          Add New
                        </div>
                      </div> : ""
                  }
                </div>
              </div>
            )
          }
          <div className="advice mt-4">
            <div className="heading">Advice</div>
            {
              // (userRole === MocUserRole.PHYSIOTHERAPIST &&
              //   (
              //     staffType?.toLowerCase() === "physiotherapist" ||
              //     selectedIpdTab === "Physiotherapist"
              //   )
              // ) ?
              <div className="textarea">
                <textarea
                  cols={50}
                  rows={5}
                  value={consultantNotesData?.advice}
                  onChange={(e) =>
                    setConsultantNotesData({
                      ...consultantNotesData,
                      advice: e.target.value,
                    })
                  }
                  disabled={isReadOnly}
                  className={isReadOnly ? "disabled" : ""}
                />
              </div>
              // :
              // <InputField
              //   value={consultantNotesData?.advice}
              //   handleChange={(e) =>
              //     setConsultantNotesData({
              //       ...consultantNotesData,
              //       advice: e.target.value,
              //     })
              //   }
              //   readOnly={isReadOnly}
              // />
            }
          </div>
          <div className="next-visit mt-4">
            <div className="heading">Next Visit</div>
            <div className="next">
              <div className={`col-md-3 mt-2 ${!consultantNotesData?.nextVisit ? "test-none" : ""}`}>
                <InputField
                  calendar={true}
                  value={consultantNotesData?.nextVisit}
                  handleChange={(e) =>
                    setConsultantNotesData({
                      ...consultantNotesData,
                      nextVisit: e.target.value,
                      nextVisit1: "",
                      nextVisit2: "",
                    })
                  }
                  readOnly={consultantNotesData?.nextVisit1 || isReadOnly}
                  placeholder="Select Date"
                />
              </div>
              <div className={`col-md-1 mt-2 test-none`}>
                <div className="or text-center">OR</div>
              </div>
              <div className={`col-md-3 mt-2 ${!consultantNotesData?.nextVisit1 ? "test-none" : ""}`}>
                <InputField
                  placeholder="Number"
                  value={consultantNotesData?.nextVisit1}
                  handleChange={(e) => {
                    const value = e.target.value
                    let res = ""
                    value.split("").forEach((ele) => {
                      let k = ele.charCodeAt(0)
                      if (k >= 48 && k <= 57) {
                        res += ele
                      }
                    })
                    setConsultantNotesData({
                      ...consultantNotesData,
                      nextVisit1: res,
                      nextVisit: "",
                    })
                  }}

                  // readOnly={isReadOnly}
                  readOnly={(consultantNotesData?.nextVisit) ||
                    isReadOnly
                  }
                />
              </div>
              <div className={`col-md-3 mt-2  ${!consultantNotesData?.nextVisit2 ? "test-none" : ""}`}>
                {/* <Dropdown
                  options={daysofYear?.daysofweek}
                  selected={consultantNotesData?.nextVisit2}
                  width={"250px"}
                  placeholder="Select Duration"
                  updateDropdown={(options: any) =>
                    setConsultantNotesData({
                      ...consultantNotesData,
                      nextVisit2: options,
                    })
                  }
                  disable={isReadOnly}
                /> */}
                <Select
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      border: "1px solid #ccd0e7",
                      borderRadius: "10px"
                    })
                  }}
                  options={monthView}
                  defaultValue={consultantNotesData?.nextVisit2}
                  onChange={(option: any) => {
                    setConsultantNotesData({
                      ...consultantNotesData,
                      nextVisit2: option?.value,
                    })
                  }}
                  placeholder="Select Duration..."
                  value={monthView.filter(({ label }: any) => label === consultantNotesData?.nextVisit2)}
                  isDisabled={(consultantNotesData?.nextVisit) ||
                    isReadOnly} />

              </div>
            </div>
          </div>
          <div className="referred-to mt-4">
            <div className="heading">Referred to:</div>
            {referredTos?.map((e: any, index: any) => {
              return (
                <>
                  <div className="referred-to-field mb-2">
                    <div className="col-md-3">
                      <label htmlFor="">{index + 1}. Consultant Name</label>
                      <Select
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: "1px solid #ccd0e7",
                            borderRadius: "10px"
                          })
                        }}
                        className="country-select"
                        options={referalConsultantsOptions}
                        onChange={(option: any) => {
                          if (option?.label === "Others") {
                            const referredToFormatted: any = referredTos?.map((ele: any, i: any) => {
                              if (i === index) {
                                return {
                                  ...ele, ...{ doctorName: option?.label, speciality: "", phoneNo: "", emailId: "", doctorNameOthers: "" }
                                }
                              } else {
                                return { ...ele }
                              }
                            })
                            setReferredTos(referredToFormatted)
                          } else {
                            const referredToFormatted: any = referredTos?.map((ele: any, i: any) => {
                              if (i === index) {
                                const foundObj: any = referalConsultants?.find((e: any) => e?.id === option?.value)
                                const temp: any = {
                                  ...ele, ...{
                                    doctorName: option?.label,
                                    speciality: foundObj?.specialization ? foundObj?.specialization : "",
                                    phoneNo: foundObj?.phoneNumber ? foundObj?.phoneNumber : "",
                                    emailId: foundObj?.emailId ? foundObj?.emailId : ""
                                  }
                                }
                                delete temp["doctorNameOthers"]
                                return temp
                              } else {
                                return { ...ele }
                              }
                            })
                            setReferredTos(referredToFormatted)
                          }
                        }}
                        placeholder="Consultant Name"
                        value={referalConsultantsOptions.filter(
                          ({ label }: any) =>
                            label === e?.doctorName
                        )}
                        isDisabled={isReadOnly}
                      />
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="">Speciality</label>
                      {/* <Select
                      options={specialityName}
                      defaultValue={referredTos[index].speciality}
                      onChange={(option: any) => {
                        const values = [...referredTos]
                        values[index].speciality = option?.value
                        setReferredTos([...values])
                      }}
                      value={specialityName.filter(({ label }: any) => label === referredTos[index].speciality)}
                      isDisabled={(referredTos[index].doctorName === "" ? true : false) || isReadOnly}
                    /> */}
                      <InputField
                        placeholder="Speciality"
                        handleChange={(e) => {
                          const values: any = [...referredTos]
                          values[index].speciality = e.target.value
                          setReferredTos([...values])
                        }}
                        value={e?.speciality}
                        readOnly={(referredTos[index].doctorName === "" ? true : false) || isReadOnly}
                      />

                    </div>
                    <div className="col-md-2">
                      <label htmlFor="">Phone No.</label>
                      <InputField
                        placeholder="Phone No"
                        handleChange={(e) => {
                          const value = e.target.value
                          let res = ""
                          value?.split("")?.forEach((ele: any) => {
                            let k = ele?.charCodeAt(0)
                            if (k >= 48 && k <= 57) {
                              res += ele
                            }
                          })
                          if (res?.length <= 10) {
                            const values = [...referredTos]
                            values[index].phoneNo = res
                            setReferredTos([...values])
                          }
                        }}
                        value={referredTos[index].phoneNo}
                        readOnly={
                          (referredTos[index].doctorName === "" ? true : false) || isReadOnly
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="">Email ID</label>
                      <InputField
                        placeholder="Email ID"
                        handleChange={(e) => {
                          const values = [...referredTos]
                          values[index].emailId = e.target.value
                          setReferredTos([...values])
                        }}
                        value={referredTos[index].emailId}
                        readOnly={
                          (referredTos[index].doctorName === "" ? true : false) || isReadOnly
                        }
                      />
                    </div>
                    {referredTos.length > 1 ? (
                      !isReadOnly ?
                        <div
                          className="delete-icon"
                          onClick={() => {
                            if (referredTos.length > 1) {
                              const values = [...referredTos]
                              values.splice(index, 1)
                              setReferredTos(values)
                            }
                          }}
                        >
                          <img src="../../assets/images/delete-icon.svg" alt="" />
                        </div> : "") : (
                      !isReadOnly ?
                        <div
                          className="delete-icon"
                          style={{ cursor: "not-allowed" }}
                        >
                          <img src="../../assets/images/delete-icon.svg" alt="" />
                        </div> : ""
                    )
                    }
                  </div>
                  {
                    e?.doctorName === "Others" && (
                      <div className="referred-to-field mb-2">
                        <div className="col-md-3 col-lg-3">
                          <InputField
                            placeholder="Name"
                            handleChange={(e) => {
                              const values: any = [...referredTos]
                              values[index].doctorNameOthers = e.target.value
                              setReferredTos([...values])
                            }}
                            value={e?.doctorNameOthers}
                            readOnly={(referredTos[index].doctorName === "" ? true : false) || isReadOnly}
                          />
                        </div>
                      </div>
                    )
                  }
                </>
              )
            })}
            {
              !isReadOnly ?
                <div className="comorbidities add-new">
                  <div
                    className="add-new-button"
                    onClick={() => setReferredTos([...referredTos, referredTo])}
                  >
                    Add New
                  </div>
                </div> : ""
            }
          </div>
          {

            (
              (userRole === MocUserRole.GENETIC_COUNSELLOR && staffType?.toLowerCase() === "genetic_counsellor") ||
              selectedIpdTab === "Genetic Counsellor"
            )
              ||
              (
                (userRole === MocUserRole.PHYSIOTHERAPIST && staffType?.toLowerCase() === "physiotherapist") ||
                selectedIpdTab === "Physiotherapist"
              )
              ||
              (
                (userRole === MocUserRole.PSYCHOLOGIST && appointmentDetails?.staffType?.toLowerCase() === "psychologist") ||
                selectedIpdTab === "Psychologist"
              )
              ? (
                <SurveyComponent
                  css={defaultSurveyConfig.defaultSurveyCSS}
                  data={signatureData}
                  json={templateJSON}
                  onComplete={(survey: any) => {
                    const data = survey.data
                    setSignatureData(data)
                    handleSurveyCompletion()
                  }}
                  hideDot={true}
                />
              ) : (
                <div className="save-button mt-4">
                  {isReadOnly ? "" : <Button text="Save" type="submit" id="save" ></Button>}
                </div>
              )
          }
        </div>
      </form>
      <PrintConsultantNotes
        prescriptionPlansPrint={[]}
        testsRequestedPrint={
          Array.isArray(testsRequested) && testsRequested?.length > 0 ?
            [...testsRequested]?.map((each: any) => {
              return { ...each, addToPrint: true }
            })
            : []
        }
        followUpData={consultantNotesData}
        consultantNotesData={consultantNotesData}
        appointmentDetails={appointmentDetails}
        referredTos={referredTos}
        patientDetail={patientDetail}
        notes={notes}
        componentRef={followUpPrintRef}
        origin={getOriginOfPrint()}
        templateJSON={templateJSON}
        signatureData={signatureData}
        smartSummaryData={smartSummaryData}
      />
    </>
  )
}
